import React, { useEffect } from 'react';
import { ButtonType } from '@prisjakt/ui/button/variants';
import type { ExperimentValue } from 'src/components/experiment';
import { ExperimentContext } from 'src/components/experiment';
import {
  Dropdown,
  DropdownContent,
  DropdownToggle,
} from '@prisjakt/ui/dropdown';
import { Direction } from '@prisjakt/ui';
import { ExperimentsList } from './experiments-list';

type EditorProps = Pick<
  ExperimentValue<unknown>,
  'experiments' | 'selectVariant' | 'selectedVariants'
>;

const Editor: React.FC<EditorProps> = props => {
  const [mounted, setMounted] = React.useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Dropdown>
      <DropdownToggle onlyIcon type={ButtonType.TEXT}>
        <img
          width="20"
          height="20"
          alt="Experiment Editor"
          src="https://cdn.pji.nu/g/logo/icon192x192.png"
        />
      </DropdownToggle>
      <DropdownContent alignment={Direction.Down} placement={Direction.Right}>
        <ExperimentsList {...props} />
      </DropdownContent>
    </Dropdown>
  );
};

export const ExperimentEditorDesktop = () => (
  <ExperimentContext.Consumer>
    {({ showEditor, ...rest }) => {
      if (!showEditor) {
        return null;
      }
      return <Editor {...rest} />;
    }}
  </ExperimentContext.Consumer>
);
